// ✅ CORRECT
import axios from "axios";

export const authFetch = axios.create({
  baseURL: "http://localhost:5001/api",
  withCredentials: true,
});

authFetch.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});